export default "__VITE_ASSET__e262663e__"